import React from 'react'
import { Navbar, NavDropdown} from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'
import { enStyle } from '../../style/enStyle'
import { faStyle } from '../../style/faStyle'
import { VscSignOut } from 'react-icons/vsc';
import { MdLanguage } from 'react-icons/md';
import {IoMdMail} from 'react-icons/io'
import './style.scss'

const DashboardNavbar = () => {
  let userdata = JSON.parse(localStorage.getItem("user"))
  const {t, i18n} = useTranslation();
  const lang = localStorage.getItem('lang')
  
  const changeLangToFa = () => { localStorage.setItem("lang", "fa"); i18n.changeLanguage("fa"); faStyle()}
  const changeLangToEn = () => { localStorage.setItem("lang", "en"); i18n.changeLanguage("en"); enStyle()}
  const changeLangToAr = () => { localStorage.setItem("lang", "ar"); i18n.changeLanguage("ar"); faStyle()}

    return (
        <div>
          <div className='dashboard_navbar'>
              <Navbar>
                <Navbar.Toggle />
                <div className='user_helper'>
                  <Navbar.Collapse className="justify-content-end user_help">
                    <NavDropdown title={userdata ? userdata.title : t("user")} id="user_help">
                        <Link to="/dashboard/account">{t("user_account")}</Link>
                        <Link to="/">{t("main_page")}</Link>
                    </NavDropdown>
                  </Navbar.Collapse>
                  {userdata && userdata.role === "ADMIN-CO" && 
                    <>
                      <Link to="/dashboard/company-manager-messages" className='messages_icon'>
                        <IoMdMail/>
                        <span>{userdata.message_count}</span>
                      </Link>
                    </>
                  }
                  <Navbar.Collapse className="justify-content-end">
                    <NavDropdown title={<MdLanguage />} id="lang">
                        <h6 onClick={changeLangToFa}><img src="/assets/img/icons/fa.png" alt="fa" />{t("fa")}</h6>
                        <h6 onClick={changeLangToEn}><img src="/assets/img/icons/en.png" alt="en" />{t("en")}</h6>
                        <h6 onClick={changeLangToAr}><img src="/assets/img/icons/ar.png" alt="ar" />{t("ar")}</h6>
                    </NavDropdown>
                  </Navbar.Collapse>
            
                  <Link to="/logout" className='signout_icon' style={lang === 'en' ? {transform: 'rotate(0deg)'} : {transform: 'rotate(180deg)'}}><VscSignOut/></Link>
                </div>
              </Navbar>
          </div>
      </div>
    )
}

export default DashboardNavbar
